import type { UnprefixedOrganizationNumber } from '#shared/organization-number'

export function useBrregUnitQuery(orgNo: MaybeRefOrGetter<UnprefixedOrganizationNumber | undefined | null>) {
  return useQuery({
    queryKey: ['brreg', 'unit', orgNo] as const,
    staleTime: 1000 * 60 * 60 * 24,
    enabled: computed(() => !!toValue(orgNo)),
    queryFn: ({ signal, queryKey }) => fetchOrganizationFromBrreg(
      toValue(queryKey[2])!,
      signal,
    ),
  })
}
